var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('numbering-check-settings',{attrs:{"model-name":"proformainvoice","document-label":"le fatture proforma"}})}
var staticRenderFns = []

export { render, staticRenderFns }